import * as api from "app/api/planning"
import { SagaIterator } from "redux-saga"
import { call, put, takeLatest } from "redux-saga/effects"
import * as notificationActions from "../notifications/notifications.actions"
import * as actions from "./hrGeneralLeaves.actions"
import { handleError } from "../errorHandler/errorHandler.saga"

export function* getHrGeneralLeavesFlow(action: actions.GetHrGeneralLeavesAction): SagaIterator {
  try {
    const { hrGeneralLeavesRequestParams } = action.payload
    const response = yield call(api.getHrGeneralLeaves, hrGeneralLeavesRequestParams)
    yield put(actions.getHrGeneralLeavesSuccess(response?.data))
  } catch (e) {
    yield put(actions.getHrGeneralLeavesFail(e))
    yield call(handleError, { error: e })
  }
}

export function* postHrGeneralLeaveFlow(action: actions.PostHrGeneralLeaveAction): SagaIterator {
  try {
    const { hrGeneralLeaves } = action.payload
    const response = yield call(api.postHrGeneralLeaves, hrGeneralLeaves)
    yield put(actions.postHrGeneralLeaveSuccess(response?.data))
    yield put(
      notificationActions.show({
        id: "postRequest",
        message: "confirmationDialog.create.generalLeaves.message",
        variant: "success",
      }),
    )
  } catch (e) {
    yield put(actions.postHrGeneralLeaveFail(e))
    yield call(handleError, { error: e })
  }
}

export function* deleteHrGeneralLeaveFlow(action: actions.DeleteHrGeneralLeaveAction): SagaIterator {
  try {
    const { hrGeneralLeaves } = action.payload

    const response = yield call(api.deleteHrGeneralLeaves, hrGeneralLeaves)
    yield put(actions.deleteHrGeneralLeaveSuccess(response?.data))
    yield put(
      notificationActions.show({
        id: "postRequest",
        message: "confirmationDialog.delete.generalLeaves.message",
        variant: "success",
      }),
    )
  } catch (e) {
    yield put(actions.deleteHrGeneralLeaveFail(e))
    yield call(handleError, { error: e })
  }
}

export default function* hrGeneralLeavesSaga(): SagaIterator {
  yield takeLatest(actions.Types.GET, getHrGeneralLeavesFlow)
  yield takeLatest(actions.Types.POST, postHrGeneralLeaveFlow)
  yield takeLatest(actions.Types.DELETE, deleteHrGeneralLeaveFlow)
}
